import { Field } from './Field';
import { IRangeField } from './IRangeField';
import { ComparisonType } from './ComparisonType';

export class DateRangeField extends Field implements IRangeField<Date> {
  public begin: Date;
  public end: Date;

  constructor(name: string, description: string, begin: Date = null, end: Date = null, comparisonType: ComparisonType = null) {
    super(name, description, DateRangeField.typeName(), comparisonType);
    this.begin = begin;
    this.end = end;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.DateRangeField";
  }
}
